import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SECRET_KEY } from './recaptcha-info';
import { CEUMA_URL_AUTH_API, CEUMA_URL_API,  } from 'app/config';

const AUTH_API_URL = CEUMA_URL_AUTH_API + '/recaptchaValidate';

@Injectable({
  providedIn: 'root'
})
export class RecaptchaService {

  constructor(private httpClient: HttpClient) { }
  validateRecaptchaToken(tokenResponse){
    return this.httpClient.post(`${AUTH_API_URL}`, tokenResponse);
  }
}
